

import { isNotEmptyArray } from '@brg/toolbox';
import {
    createDefaultDesigner,
    createDefaultFile,
    createDefaultLangObject,
    createDefaultPoint,
    createDefaultTeam,
} from './Defaults';
import { Designer, Project } from '@brg/api';
import { TFile, TGlobal } from '@brg/api';

/**
 *  @deprecated
 */
export const DefaultHandler = {
    /**
     *  @deprecated
     * @param source
     */
    defaultProject(source: Project<TGlobal>): Project<TGlobal> {
        const data = { ...source };
        if (!isNotEmptyArray(data.title)) data.title = createDefaultLangObject('Untitled');

        if (!data.pointId || !data.point || !data.point.pointId) {
            data.point = createDefaultPoint() as any;
        }
        if (!isNotEmptyArray(data.authors)) {
            data.authors = [createDefaultDesigner() as any];
        }
        if (!data.author) {
            data.author = createDefaultDesigner() as any;
        }
        if (!isNotEmptyArray(data.tags)) {
            data.tags = [];
            data.tagsID = [];
        }
        if (!isNotEmptyArray(data.tagsName)) {
            data.tagsName = [] as never;
        }

        if (!data.titleImage || !(data.titleImage as TFile).url) data.titleImage = createDefaultFile();
        if (!data.categoryName) data.categoryName = createDefaultLangObject('Undefined category') as never;
        if (!data.team) data.team = createDefaultTeam() as any;
        return data;
    },

    /**
     *  @deprecated
     * @param source
     */
    defaultDesigner(source: Partial<Designer<TGlobal>>): Designer<TGlobal> {
        const data = { ...source };
        if (!data.name) data.name = createDefaultLangObject('Unnamed');
        if (!data.surName) data.surName = createDefaultLangObject('Unnamed');
        if (!data.avatar || !isNotEmptyArray(data.avatar)) data.avatar = createDefaultFile();
        return data as Designer<TGlobal>;
    },
};


import { isNotEmptyArray } from '@brg/toolbox';
import {
    createDefaultDesigner,
    createDefaultFile,
    createDefaultLangObject,
    createDefaultPoint,
    createDefaultTeam,
} from './Defaults';
import { Designer, Project } from '@brg/api';
import { TFile, TGlobal } from '@brg/api';

/**
 *  @deprecated
 */
export const DefaultHandler = {
    /**
     *  @deprecated
     * @param source
     */
    defaultProject(source: Project<TGlobal>): Project<TGlobal> {
        const data = { ...source };
        if (!isNotEmptyArray(data.title)) data.title = createDefaultLangObject('Untitled');

        if (!data.pointId || !data.point || !data.point.pointId) {
            data.point = createDefaultPoint() as any;
        }
        if (!isNotEmptyArray(data.authors)) {
            data.authors = [createDefaultDesigner() as any];
        }
        if (!data.author) {
            data.author = createDefaultDesigner() as any;
        }
        if (!isNotEmptyArray(data.tags)) {
            data.tags = [];
            data.tagsID = [];
        }
        if (!isNotEmptyArray(data.tagsName)) {
            data.tagsName = [] as never;
        }

        if (!data.titleImage || !(data.titleImage as TFile).url) data.titleImage = createDefaultFile();
        if (!data.categoryName) data.categoryName = createDefaultLangObject('Undefined category') as never;
        if (!data.team) data.team = createDefaultTeam() as any;
        return data;
    },

    /**
     *  @deprecated
     * @param source
     */
    defaultDesigner(source: Partial<Designer<TGlobal>>): Designer<TGlobal> {
        const data = { ...source };
        if (!data.name) data.name = createDefaultLangObject('Unnamed');
        if (!data.surName) data.surName = createDefaultLangObject('Unnamed');
        if (!data.avatar || !isNotEmptyArray(data.avatar)) data.avatar = createDefaultFile();
        return data as Designer<TGlobal>;
    },
};
